import { combineEpics } from 'redux-observable';
import authFlowEpic from './auth';
import registerFlowEpic from './register';

export const authEpic = combineEpics(authFlowEpic, registerFlowEpic);
